import styled from "styled-components";

export const DashboardWrapper = styled.div`
.advanced-search-btn {
    background: transparent;
    background-color: transparent;
    color: var(--text);
    border: 2px solid var(--borderLight);
}
.advanced-search-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
    @media (max-width: 500px) {
        flex-wrap: wrap;
    }
}
`